export const actions = {
  SHEET_MODAL_OPEN: 'SHEET_MODAL_OPEN',
  SHEET_MODAL_CLOSE: 'SHEET_MODAL_CLOSE',
};

export function openSheetModal(name) {
  return dispatch =>
    dispatch({
      type: actions.SHEET_MODAL_OPEN,
      payload: {
        name,
      },
    });
}

export function closeSheetModal() {
  return dispatch =>
    dispatch({
      type: actions.SHEET_MODAL_CLOSE,
    });
}
